module.exports = __webpack_public_path__ + "static/media/clock-icon.c03d923f.svg";